export default "__VITE_ASSET__D0FA8Z58__"